import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./SidePanel.scss";
import Text from "../../Atomsv2/Text/Text";
import Button from "../../Atomsv2/Button/Button";

const CLOSE_ANIMATION_MS = 320;

const SidePanel = ({
    open,
    onClose,
    title,
    subtitle,
    icon,
    headerClass,
    footer,
    width = "360px",
    placement = "right",
    children,
    className,
    tabToClose = true
}) => {
    const [closing, setClosing] = useState(false);

    const handleClose = () => {
        setClosing(true);
    };

    const handleOverlayClick = () => {
        if (tabToClose) handleClose();
    };

    const handleAnimationEnd = () => {
        if (closing) {
            setClosing(false);
            onClose?.();
        }
    };

    useEffect(() => {
        if (!open) return;
        setClosing(false);
        const handleKey = (e) => { if (e.key === "Escape") handleClose(); };
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, [open]);

    useEffect(() => {
        if (!closing) return;

        // Fallback para asegurar el cierre si animationend no se dispara.
        const timer = setTimeout(() => {
            setClosing(false);
            onClose?.();
        }, CLOSE_ANIMATION_MS);

        return () => clearTimeout(timer);
    }, [closing, onClose]);

    if (!open && !closing) return null;

    const slideIn = placement === "left" ? "animate__slideInLeft" : "animate__slideInRight";
    const slideOut = placement === "left" ? "animate__slideOutLeft" : "animate__slideOutRight";

    return createPortal(
        <div
            className={`SidePanel-overlay placement-${placement} ${closing ? "is-closing" : ""} ${className || ""}`}
            onClick={handleOverlayClick}
            role="dialog"
            aria-modal="true"
            aria-label={title}
        >
            <div
                className={`SidePanel animate__animated ${closing ? slideOut : slideIn}`}
                style={{ width, maxWidth: "95vw" }}
                onClick={e => e.stopPropagation()}
                onAnimationEnd={handleAnimationEnd}
            >
                {/* header */}
                <div className={`sp-header ${headerClass || ""}`}>
                    <div className="sp-header-left">
                        {icon && (
                            <div className="sp-icon-wrap">
                                <span className="icon" data-icon={icon} />
                            </div>
                        )}
                        <div className="sp-titles">
                            {title && <Text color={"var(--font-color-light)"} size="medium" className="sp-title" weight={800}>{title}</Text>}
                            {subtitle && <Text color={"var(--font-color-light)"} className="sp-subtitle" size="small">{subtitle}</Text>}
                        </div>
                    </div>
                    <Button
                        className="sp-close"
                        width="32px"
                        onClick={handleClose}
                        aria-label="Cerrar panel"
                        icon={'close'}
                    >
                    </Button>
                </div>
                {/* contenido */}
                <div className="sp-body">
                    {children}
                </div>
                {/* footer */}
                {footer && (
                    <div className="sp-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default SidePanel;
